import type { EvinAnalysisResult } from '../../../shared/types';

/* Badges de verdict / niveau de risque — extraits de ResultsDisplay.tsx
 * (anciennes fonctions verdictBadge / riskBadge) en composants réutilisables.
 * Markup et classes strictement identiques. */

export function VerdictBadge({ verdict }: { verdict: EvinAnalysisResult['verdict'] | string }) {
  const styles: Record<string, string> = {
    CONFORME: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
    VIGILANCE: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
    RISQUE_ELEVE: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
    RISQUE_MODERE: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
    NON_CONFORME: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  };
  const labels: Record<string, string> = {
    CONFORME: 'Conforme',
    VIGILANCE: 'Vigilance',
    RISQUE_ELEVE: 'Risque élevé',
    RISQUE_MODERE: 'Risque élevé',
    NON_CONFORME: 'Non conforme',
  };
  return (
    <span className={`px-3 py-1 rounded-full text-sm font-semibold ${styles[verdict] ?? ''}`}>
      {labels[verdict] ?? verdict}
    </span>
  );
}

export function RiskBadge({ level }: { level: string }) {
  const styles: Record<string, string> = {
    'Faible': 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
    'Moyen': 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
    'Élevé': 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  };
  return <span className={`px-2 py-0.5 rounded text-xs font-medium ${styles[level] ?? ''}`}>{level}</span>;
}
